import { render } from "./TheC01ItemFormOnlyTypeInCart.vue?vue&type=template&id=39a6d3a0&scoped=true&ts=true"
import script from "./TheC01ItemFormOnlyTypeInCart.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemFormOnlyTypeInCart.vue?vue&type=script&lang=ts"

import "./TheC01ItemFormOnlyTypeInCart.vue?vue&type=style&index=0&id=39a6d3a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a6d3a0"]])

export default __exports__